import React from 'react';

export const YandexTGOBlock = () => (
  <>
    <div id="yandex_rtb_R-A-16352629-1" style={{ maxHeight: '230px', width: '100%' }} />
    <script dangerouslySetInnerHTML={{
      __html: `window.yaContextCb.push(() => {
            Ya.Context.AdvManager.render({
              "blockId": "R-A-16352629-1",
              "renderTo": "yandex_rtb_R-A-16352629-1"
            })
          })`,
    }}
    />
  </>
);
